import React from "react";
import Markdown from "@/components/Markdown";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

export const Title = ({ children, className = "", sx = {} }) => (
  <Typography
    variant="h2"
    className={className}
    sx={{ fontSize: 34, color: "inherit", ...sx }}
  >
    {children}
  </Typography>
);

export const SubTitle = ({ children, className = "", sx = {} }) => (
  <Typography
    variant="body1"
    component="div"
    className={className}
    sx={{ fontSize: 16.8, color: "inherit", ...sx }}
  >
    <Markdown>{children}</Markdown>
  </Typography>
);

export const Content = ({ children, className = "", sx = {} }) => (
  <Typography
    variant="body1"
    component="div"
    className={className}
    sx={{ color: "inherit", ...sx }}
  >
    <Markdown>{children}</Markdown>
  </Typography>
);

export const PreTitle = ({ children }) => (
  <Typography
    variant="body1"
    component="div"
    sx={{
      fontSize: 14,
      fontWeight: 700,
      textAlign: "center",
      textTransform: "uppercase",
      position: "relative",
      width: 300,
      margin: "0 auto",
      color: "inherit",
      "&:after": {
        content: "\"\"",
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: "0.7em",
        borderTop: "1px solid #2b4d68",
        zIndex: 0
      }
    }}
  >
    <Markdown
      style={{
        position: "relative",
        padding: "0 10px",
        backgroundColor: "#F3F7FB",
        zIndex: 1
      }}
    >
      {children}
    </Markdown>
  </Typography>
);

const genericPropTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
};

Title.propTypes = genericPropTypes;
SubTitle.propTypes = genericPropTypes;
Content.propTypes = genericPropTypes;
